'use strict';

var cov_2gkwczxvbs = function () {
  var path = '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/constants.js',
      hash = '53c718c52125e686075576934555d1fb533ae40a',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/builds/CS-Development/overlay-messaging/src/main/components/cookies-consent/constants.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 47
        },
        end: {
          line: 1,
          column: 74
        }
      },
      '1': {
        start: {
          line: 2,
          column: 49
        },
        end: {
          line: 2,
          column: 78
        }
      },
      '2': {
        start: {
          line: 3,
          column: 48
        },
        end: {
          line: 3,
          column: 76
        }
      },
      '3': {
        start: {
          line: 4,
          column: 39
        },
        end: {
          line: 4,
          column: 44
        }
      },
      '4': {
        start: {
          line: 5,
          column: 40
        },
        end: {
          line: 5,
          column: 51
        }
      },
      '5': {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 7,
          column: 185
        }
      },
      '6': {
        start: {
          line: 8,
          column: 37
        },
        end: {
          line: 8,
          column: 46
        }
      },
      '7': {
        start: {
          line: 9,
          column: 38
        },
        end: {
          line: 9,
          column: 47
        }
      },
      '8': {
        start: {
          line: 10,
          column: 36
        },
        end: {
          line: 10,
          column: 45
        }
      },
      '9': {
        start: {
          line: 11,
          column: 34
        },
        end: {
          line: 11,
          column: 45
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MSG_COOKIES_CONSENT_PUB_DISPLAY = exports.MSG_COOKIES_CONSENT_PUB_DISPLAY = (cov_2gkwczxvbs.s[0]++, 'cp.cookiesConsent.display');
var MSG_COOKIES_CONSENT_SUB_DISPLAYED = exports.MSG_COOKIES_CONSENT_SUB_DISPLAYED = (cov_2gkwczxvbs.s[1]++, 'cp.cookiesConsent.displayed');
var MSG_COOKIES_CONSENT_SUB_ACCEPTED = exports.MSG_COOKIES_CONSENT_SUB_ACCEPTED = (cov_2gkwczxvbs.s[2]++, 'cp.cookiesConsent.accepted');
var CRM_COOKIES_CONSENT_KEY = exports.CRM_COOKIES_CONSENT_KEY = (cov_2gkwczxvbs.s[3]++, 'cdb');
var CRM_COOKIES_LANGUAGE_KEY = exports.CRM_COOKIES_LANGUAGE_KEY = (cov_2gkwczxvbs.s[4]++, 'cust_lang');
var CRM_COOKIES_CONTENT_URL = exports.CRM_COOKIES_CONTENT_URL = (cov_2gkwczxvbs.s[5]++, 'https://search.williamhill--ENV--.com/gaming/s/search.html?collection=translations-api&profile=_default&form=translation&meta_module=legal&num_ranks=99999999&fmo=1&sort=metaposition');
var CRM_COOKIES_TITLE_KEY = exports.CRM_COOKIES_TITLE_KEY = (cov_2gkwczxvbs.s[6]++, '1167580');
var CRM_COOKIES_BUTTON_KEY = exports.CRM_COOKIES_BUTTON_KEY = (cov_2gkwczxvbs.s[7]++, '1167613');
var CRM_COOKIES_TEXT_KEY = exports.CRM_COOKIES_TEXT_KEY = (cov_2gkwczxvbs.s[8]++, '1167594');
var CRM_COOKIES_DEVICE = exports.CRM_COOKIES_DEVICE = (cov_2gkwczxvbs.s[9]++, 'wh_device');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wh/overlay-messaging/dist/components/cookies-consent/constants.js
// module id = 11
// module chunks = 0